import {
  GAME_ID,
  NUM_LEVELS,
  MASTERY_PERCENTAGE,
  REDUX_ACTIONS,
} from 'a/silabalon/data/constants';
import { getLevelData, getPracticeIndices } from 'a/silabalon/data/curriculum';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const NUM_PRACTICE_SETS = 3;

const initialState = {
  progress: 0,
  currentLevel: 0,
  numQuestions: 0,
  highestLevelListView: 0,
  mastery: 0,
  practiceIndices: {},
  currentPracticeItem: null,
  isOnboardingCompleted: false, // true, if user already completed first time onboarding
  isDragging: false,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INCREMENT_PROGRESS:
      return {
        ...state,
        progress: payload,
      };

    case REDUX_ACTIONS.UPDATE_CURRENT_LEVEL: {
      const { currentLevel } = state;
      let { practiceIndices } = state;
      const levelSelected = payload;

      const { questions } = getLevelData(levelSelected);
      if (currentLevel !== levelSelected) {
        practiceIndices = getPracticeIndices();
      }

      return {
        ...state,
        currentLevel: levelSelected,
        numQuestions: questions.length,
        practiceIndices,
      };
    }

    case REDUX_ACTIONS.UPDATE_HIGHEST_LIST_VIEW: {
      return {
        ...state,
        highestLevelListView: payload,
      };
    }

    case REDUX_ACTIONS.SET_MASTERY:
      return {
        ...state,
        mastery: payload,
      };

    case REDUX_ACTIONS.UPDATE_PRACTICE_ROUND: {
      // each new time a specific sound needs to be practiced,
      // queue up a new practice item. Loop as necessary.
      const { practiceIndices } = state;
      if (practiceIndices[payload] === NUM_PRACTICE_SETS) {
        practiceIndices[payload] = 1;
      } else {
        practiceIndices[payload]++;
      }

      return {
        ...state,
        currentPracticeItem: payload,
        practiceIndices,
      };
    }

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const gameData = {
        ...initialState,
        ...stateData[GAME_ID].GameData,
      };

      gameData.isOnboardingCompleted = !!gameData.isOnboardingCompleted;

      return gameData;
    }

    case REDUX_ACTIONS.INTERRUPT_STANDARD_ROUND: {
      return {
        ...state,
        mastery: 0,
      };
    }

    case REDUX_ACTIONS.COMPLETE_STANDARD_ROUND: {
      const { mastery, numQuestions } = state;
      let { highestLevelListView } = state;

      if (highestLevelListView < NUM_LEVELS - 1 && mastery / numQuestions >= MASTERY_PERCENTAGE) {
        highestLevelListView++;
      }

      return {
        ...state,
        mastery: 0,
        highestLevelListView,
      };
    }

    case REDUX_ACTIONS.UPDATE_ONBOARDING_METADATA: {
      return {
        ...state,
        isOnboardingCompleted: true,
      };
    }

    case REDUX_ACTIONS.QUICK_ROUND: {
      const { numQuestions } = state;
      let { highestLevelListView } = state;

      const isPass = payload;
      const numCorrect = isPass ? numQuestions : 0;
      if (isPass && highestLevelListView < NUM_LEVELS - 1) {
        highestLevelListView++;
      }

      return {
        ...state,
        mastery: numCorrect,
        progress: numQuestions,
        highestLevelListView,
      };
    }

    case REDUX_ACTIONS.SET_IS_DRAGGING:
      return {
        ...state,
        isDragging: payload,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
